<div class="page-wrapper section-hr-direct">
    <app-multi-lingual></app-multi-lingual>
    <div class="new-login-container">
        <div class="heading">{{'Login.WelComeText' | translate}}</div>
        <ul class="nav nav-tabs" role="tablist">
            <li role="presentation">
                <a [routerLink]="['/login']" routerLinkActive="router-link-active" role="tab"
                    data-toggle="tab">{{'Login.Title'|translate}}</a>
            </li>
            <li role="presentation" class="active">
                <a [routerLink]="['/register']" routerLinkActive="router-link-active" role="tab"
                    data-toggle="tab">{{'Register.Title'|translate}}</a>
            </li>
        </ul>

        <div class="tab-content">
            <div role="tabpanel" class="tab-pane active login" id="login">
               <span >{{errorMessage}}</span>
                <form [formGroup]="registerForm" novalidate
                    (ngSubmit)="register(registerForm.value, registerForm.valid)">

                    <label>{{'Register.TaxId.Label' | translate}}<span class="required">*</span></label>
                    <span class="error-message"
                        *ngIf="registerForm.controls['TaxIdOrSsn'].errors?.required && registerForm.controls['TaxIdOrSsn'].touched">
                        {{'Register.TaxId.Error.Required'| translate}}
                    </span>

                    <span class="error-message"
                        *ngIf="!registerForm.controls['TaxIdOrSsn'].errors?.required && !registerForm.controls['TaxIdOrSsn'].errors?.minlength && registerForm.controls['TaxIdOrSsn'].errors?.isValid">
                        {{'Register.TaxId.Error.Exist' |translate}}
                    </span>
                    <span class="error-message"
                        *ngIf="!registerForm.controls['TaxIdOrSsn'].errors?.required && !registerForm.controls['TaxIdOrSsn'].errors?.minlength && registerForm.controls['TaxIdOrSsn'].errors?.inUse">
                        {{'Register.TaxId.Error.inUse' |translate}}
                    </span>
                    <input type="text" maxlength="10" formControlName="TaxIdOrSsn">

                    <label>{{'Register.Email.Label' | translate}}<span class="required">*</span></label>
                    <span class="error-message"
                        *ngIf="registerForm.controls['Email'].errors?.required && registerForm.controls['Email'].touched">
                        {{'Register.Email.Error.Required'| translate}}
                    </span>
                    <span class="error-message"
                        *ngIf="!registerForm.controls['Email'].errors?.required && !registerForm.controls['Email'].errors?.minlength && registerForm.controls['Email'].errors?.email">
                        {{'Register.Email.Error.Invalid' |translate}}
                    </span>
                    <span class="error-message"
                        *ngIf="!registerForm.controls['Email'].errors?.required && !registerForm.controls['Email'].errors?.isValid && registerForm.controls['Email'].errors?.isUnique">
                        {{'Register.Email.Error.Exist' |translate}}
                    </span>
                    <input type="text" formControlName="Email">

                    <label>{{'Register.Password.Label' | translate}}<span class="required">*</span></label>
                    <span class="error-message"
                        *ngIf="registerForm.controls['Password'].errors?.required && registerForm.controls['Password'].touched">
                        {{'Register.Password.Error.Required' | translate}}
                    </span>

                    <span class="error-message"
                        *ngIf="!registerForm.controls['Password'].errors?.required && !registerForm.controls['Password'].errors?.minlength && registerForm.controls['Password'].errors?.isValidPassword">
                        {{'Register.Password.Error.IsValid' | translate}}

                    </span>


                    <input type="password" formControlName="Password">

                    <label>{{'Register.ConfirmPassword.Label' | translate}}<span class="required">*</span></label>
                    <span class="error-message"
                        *ngIf="registerForm.controls['ConfirmPassword'].errors?.required && registerForm.controls['ConfirmPassword'].touched">
                        {{'Register.ConfirmPassword.Error.Required' | translate}}
                    </span>
                    <span class="error-message"
                        *ngIf="!registerForm.controls['ConfirmPassword'].errors?.required  && (registerForm.controls['Password'].value != registerForm.controls['ConfirmPassword'].value)">
                        {{'Register.ConfirmPassword.Error.MisMatch' | translate}}
                    </span>
                    <input type="password" formControlName="ConfirmPassword">
                    <div>

                        <span style="text-decoration: underline;"> {{'Common.PasswordMessage1'| translate}}</span>:
                        <br>-&nbsp;{{'Common.PasswordMessage2'| translate}}
                        <br>-&nbsp;{{'Common.PasswordMessage3'| translate}}
                        <br>-&nbsp;{{'Common.PasswordMessage4'| translate}}
                        <br>-&nbsp;{{'Common.PasswordMessage5'| translate}}
                        <br>-&nbsp;{{'Common.PasswordMessage6'| translate}}
                    </div>
                    <input type="submit" id="register" [disabled]="!registerForm.valid" class="btn btn-main"
                        value="{{'Common.Register' | translate}}" />
                </form>
            </div>



        </div>
    </div>
</div>
<app-outer-footer></app-outer-footer>